import React from 'react';
import webhook1 from 'assets/img/webhook-1.png';
import webhook2 from 'assets/img/webhook-2.png';
import webhook3 from 'assets/img/webhook-3.png';

const styles = {
	root: {
		display: "flex",
		flexDirection: "column",
		gap: "17px",
		paddingBottom: "17px"
	},
	list: {
		paddingLeft: "25px",
	},
	imageWidth: {
		width: "100vh"
	},
	inputField: {
		padding: "10px",
		width: "70vh",
		textOverflow: "ellipsis",
	},
}

function TeamsConnectors() {
	const classes = styles;

	return (

		<div style={classes.root}>
			<b>The instructions below will guide you through the process of setting up Reteam notifications only for the specific team to the RingCentral conversation of your choice.</b>
			<ol style={classes.list}>
				<li>
					Login to your ReTeam account and choose any team. (You must be super admin of that team)
				</li>
				<li>
					Go to the team information page.
				</li>
				<li>
					Click on the Team Options (dropdown) and select the (webhooks) option.
				</li>
			</ol>
			<div>
				<img style={classes.imageWidth} src={webhook1} alt='webhook-1' />
			</div>
			<span>Pop up will appear and click on the “Add webhook” button.</span>
			<img style={classes.imageWidth} src={webhook2} alt='webhook-2' />
			<span>On the next screen in the Payload Url field, enter the webhook url</span>
			<input style={classes.inputField} type='text' disabled value="Here is the webhook url" />
			<img style={classes.imageWidth} src={webhook3} alt='webhook-3' />
			<span>After the submission of the payload url, you can see your payload url in the webhooks screen.</span>
			<span>Now you can see the activity of selected team on RingCentral team. </span>
		</div>
	)
}

export default TeamsConnectors